import { Pipe, PipeTransform } from '@angular/core';
import { GfTranslateService } from '../../../../core/services/core.translate.service';

@Pipe({
    name: 'efErrorMessage'
})
export class EfErrorMessagePipe implements PipeTransform {
    constructor(private translateService: GfTranslateService) {};

    transform(errorMessage: string): string {
        switch(errorMessage) {
            case 'transition-field-required':
                return this.translateService.translate('This field is required for the specified transition');
                //This two will not be shown since we want to display only allowed elements in the select
            case 'transition-not-defined':
                return this.translateService.translate("The requested transition is not defined");
            case 'transition-role-not-allowed':
                return this.translateService.translate("You don't have enough permissions to perform this transition");
            default:
                return errorMessage;
        }
    }
};